<top-banner variant="title" [title]="selectedContractor?.name"></top-banner>

<div class="main-content">
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="row">
          <div class="col-md-2 cardtabs-wrapper">
            <app-card-tabs [tabitems]="tabitems"></app-card-tabs>
          </div>
          <div class="col-md-10">

            <!-- Message for when a user is set up by skylark admin without connecting the site owner to the contractor -->
            <div *ngIf="missingSiteOwnerLink && selectedContractor" class="warning-banner">
              <div class="temporary-information-message">
                <div>
                  <i class="fas fa-info-circle"></i>
                </div>
                <div>
                  <p>
                    There is a data mismatch for this company. Please email Skylark at the <a>controlcentre@skylarkcontrol.com</a> with the following info:
                  </p>
                  <dl class="sideways-dl">
                    <p>Missing contractor to site link</p>
                    <p>Contractor: {{ selectedContractor.id }} - {{ selectedContractor.name }} --- Site Owner: {{ siteOwnerSkylarkUserId }}</p>
                  </dl>
                </div>
              </div>
            </div>

            <h4 class="card-title">Certificates</h4>
            <div *ngIf="siteOwners.length > 1 && !isSiteOwnerView" class="mt-5 mb-5">
              <label>Sites</label>
              <p-dropdown
              class="form-control"
              [(ngModel)]="selectedSiteOwner"
              [ngModelOptions]="{standalone: true}"
              [options]="siteOwners"
              (ngModelChange)="selectedSiteOwnerChange()"
              placeholder="Select a site owner..."
              [style]="{'width':'100%'}"
              filter="true"
            ></p-dropdown>
            </div>

            <div *ngIf="!loaded" class="progress-spinner-wrapper d-flex align-items-baseline">
              <p-progressSpinner></p-progressSpinner>
            </div>

            <p *ngIf="loaded && selectedContractor && !selectedContractor.competencies?.length && selectedSiteOwner">No certificates are currently required</p>

            <div *ngIf="loaded && selectedContractor" class="mb-2 animated fadeIn">
              <div *ngFor="let competency of selectedContractor.competencies" class="compblock">
                <div class="compblock-details">
                  <b>{{competency.label}}</b>
                  <ul *ngIf="competency.status === 'PENDING' || competency.status === 'EXPIRED'">
                    <li>requires certificate</li>
                    <li>requires Site Operator approval</li>
                    <ng-container *ngIf="isHuntstown">
                      <li *ngIf="extraCompetencyInfo[competency.id]">{{extraCompetencyInfo[competency.id]}}</li>
                    </ng-container>
                  </ul>

                  <ul *ngIf="competency.status === 'REJECTED'">
                    <li><b>Rejection Comment:</b> {{competency.rejectionComments}}</li>
                  </ul>

                  <ul *ngIf="competency.status === 'APPROVED' || competency.status === 'SUBMITTED' || competency.status === 'REJECTED' || competency.status === 'EXPIRED'">
                    <div *ngFor="let file of competency.files">
                      <button type="button" class="btn btn-primary btn-link text-left" (click)="viewDocument(file.fileName)">{{ file.fileName }}</button>
                    </div>
                  </ul>

                </div>
                <p *ngIf="competency.status === 'APPROVED' || competency.status === 'SUBMITTED' || competency.status === 'REJECTED' || competency.status === 'EXPIRED'">Valid until: {{competency.expiryDate}}</p>
                <span *ngIf="competency.status === 'APPROVED'" class="badge badge-pill badge-success">Approved</span>
                <span *ngIf="competency.status === 'REJECTED'" class="badge badge-pill badge-danger">Rejected</span>
                <span *ngIf="competency.status === 'EXPIRED'" class="badge badge-pill badge-danger">Expired</span>
                <span *ngIf="competency.status === 'SUBMITTED'" class="badge badge-pill badge-warning">Pending approval of certificates</span>
                <span *ngIf="competency.status === 'PENDING'" class="badge badge-pill badge-warning">Pending upload of certificates</span>

                <button type="button" *ngIf="!isReadOnly" class="btn-link btn-danger" (click)="deleteCert(competency.linkId)"><span class="pi pi-times"></span></button>
              </div>
              <br>
              <div *ngIf="!isReadOnly" class="d-flex justify-content-end">
                <button class="btn btn-success btn-round mt-5 mb-3" (click)="openRequiredCompetencyModal()">Add a new requirement</button>
              </div>
              <div *ngIf="!isReadOnly" class="d-flex justify-content-end">
                <button class="btn btn-primary btn-link" (click)="showAddCertificateModal()">upload certificate</button>
              </div>
              <br>
              <!--     OUTAGE ACCEPTANCE    -->
              <div *ngIf="isPowerStationOwnerView || isPowerStationManagerView ">
                <h4 class="card-title">Outage Acceptances</h4>
                <div *ngIf="!loaded" class="progress-spinner-wrapper d-flex align-items-baseline">
                  <p-progressSpinner></p-progressSpinner>
                </div>

                <p *ngIf="loaded && !outageAcceptances.length">No Acceptances currently assigned</p>
                <div *ngFor="let outage of outageAcceptances" class="compblock">
                  <div class="compblock-details">
                    <b>{{ outage.course.trainingName }}</b>
                    <ul>
                      <li>{{ outage.course.description }}</li>
                      <li>Requires completion of {{ outage.course.sections.length }} sections</li>
                    </ul>
                  </div>
                  <p *ngIf="outage.courseProgress !== 'EXPIRED' && outage.courseProgress !== 'COMPLETED' ">&nbsp;</p>
                  <p *ngIf="outage.courseProgress === 'EXPIRED' || outage.courseProgress === 'COMPLETED' ">Accepted: On: {{ outage.lastModifiedDate | date: 'yyyy-MM-dd' }}</p>
                  <span *ngIf="outage.courseProgress === 'IN_PROGRESS'" class="badge badge-pill badge-warning">Started - Not Accepted</span>
                  <span *ngIf="outage.courseProgress === 'NOT_STARTED'" class="badge badge-pill badge-danger">Assigned - Not Accepted</span>
                  <span *ngIf="outage.courseProgress === 'EXPIRED'" class="badge badge-pill badge-primary">Accepted - Inactive</span>
                  <span *ngIf="outage.courseProgress === 'COMPLETED'" class="badge badge-pill badge-success">Accepted</span>
                  <button type="button" *ngIf="!isReadOnly" class="btn-link btn-danger" (click)="deleteAcceptanceAssignment(outage)"><span class="pi pi-times"></span></button>
                </div>
                <br>
                <div *ngIf="!isReadOnly" class="d-flex justify-content-end">
                  <button class="btn btn-success btn-round mt-5 mb-3" (click)="openAssignAcceptanceModal()">Assign Acceptance</button>
                </div>
                <br>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog header="New Certificate" [(visible)]="showAddCertificateTypeModal" modal="true" [baseZIndex]="1000000"
  [style]="{ width: '90vw', maxWidth: '750px' }"
  [draggable]="false"
  [resizable]="false">

  <form [formGroup]="addCertificateForm" (ngSubmit)="onAddCertificateFormSubmit()">
    <div class="row my-4">
      <div class="col-md-12 mb-4" *ngIf="competencyOptions.length">
        <div class="form-group">
          <label>Select Certificate Type <span class="required-text">(required)</span></label>
          <p-dropdown
            class="form-control"
            placeholder="Select Certificate Type"
            formControlName="competencyType"
            [options]="competencyOptions"
            optionLabel="label"
            defaultLabel="Select Certificate Type"
            [style]="{ width: '100%' }"
            filter="true"
          ></p-dropdown>
        </div>
      </div>
      <div class="col-md-12 mb-4" *ngIf="!competencyOptions.length">
        <label>Select Certificate Type</label>
        <p-dropdown class="form-control" placeholder="No competency types found. Try again later or contact support"></p-dropdown>
      </div>
      <div class="col-md-12 mb-4">
        <div class="form-group">
          <label>Expires <span class="required-text">(required)</span></label>
          <p-calendar
            class="form-control"
            formControlName="expires"
            dateFormat="dd/mm/yy"
            [yearNavigator]="true"
            [yearRange]="datepickerYearRange"
            [monthNavigator]="true"
            [minDate]="minDateValue"
            placeholder="Select Expiry Date"
            [showIcon]="true"
            [style]="{ width: '100%' }">
        </p-calendar>
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <label for="compFile" class="btn btn-primary btn-round">
            <span class="align-middle">
              <i class="pi pi-upload"></i></span> Browse Supporting Documents
          </label>
          <input
            type="file"
            class="form-control"
            name="compFile"
            id="compFile"
            accept=".pdf, image/*, .doc, .docx, .ppt, .pptx, .pps, .ppsx, .odt, .xls, .xlsx, .key"
            (change)="onFileChange($event)"
            multiple
            #fileInput
          />
          <ng-container *ngIf="selectedDocumentsArray.length">
            <p>Selected Documents:</p>
            <ul>
              <li *ngFor="let file of selectedDocumentsArray">{{ file.name }}</li>
            </ul>
          </ng-container>
        </div>
      </div>
      <div class="col-md-12">
        <span>
          Note: If the certificate you choose already exists, you will overwrite the expiry date and the files.
        </span>
      </div>
    </div>
  </form>
  <p-footer>
    <div *ngIf="!saveInProgress" class="my-4">
      <button type="button" (click)="showAddCertificateTypeModal = false" [disabled]="saveInProgress" class="my-2 btn btn-round btn-sm btn-default float-left">Cancel</button>
      <button type="button" (click)="onAddCertificateFormSubmit()" [disabled]="!addCertificateForm.valid || !areFilesAdded || saveInProgress" class="my-2 btn btn-round btn-sm btn-success">Upload</button>
      </div>
      <div *ngIf="saveInProgress" class="d-flex justify-content-center align-items-center">
        <p-progressSpinner></p-progressSpinner>
      </div>
  </p-footer>
</p-dialog>

<p-dialog header="Assign Outage Acceptance" [(visible)]="showAssignAcceptanceModal" modal="true" [baseZIndex]="1000000">
  <form *ngIf="!saveInProgress" [formGroup]="assignAcceptanceForm" (ngSubmit)="onAssignAcceptanceFormSubmit()">
    <div class="row">
      <div class="col-md-12" *ngIf="acceptanceOptions.length">
        <div class="form-group">
          <label>Select Acceptance</label>
          <p-dropdown
            class="form-control"
            placeholder="Select acceptance..."
            formControlName="acceptance"
            [options]="acceptanceOptions"
            optionLabel="label"
            defaultLabel="Select Acceptance"
            [style]="{ width: '100%' }"
            filter="true"
          ></p-dropdown>
        </div>
      </div>
      <div class="col-md-12" *ngIf="!acceptanceOptions.length">
        <label>Select Acceptance</label>
        <p-dropdown class="form-control" placeholder="No acceptances found. Try again later or contact support"></p-dropdown>
        <br>
      </div>
    </div>
  </form>
  <div *ngIf="saveInProgress" style="width: 50%; margin: 0 auto">
    <p-progressSpinner></p-progressSpinner>
  </div>
  <p-footer>
    <button type="button" (click)="showAssignAcceptanceModal = false" [disabled]="saveInProgress" class="my-2 btn btn-round btn-sm btn-default float-left">Cancel</button>
    <button type="button" (click)="onAssignAcceptanceFormSubmit()" [disabled]="!assignAcceptanceForm.valid || saveInProgress" class="my-2 btn btn-round btn-sm btn-success">Assign</button>
  </p-footer>
</p-dialog>
